<template>
  <v-wait for="subs-loading">
    <template slot="waiting">
      <div class="vue-wait-class">
        <img src="static/loading.svg" />
        <p>Cihazlar Yükleniyor...</p>
      </div>
    </template>
    <div class="container-fluid no-padding">
      <div class="row border-bottom py-3">
        <div class="col">
          <div class="dropdown mr-2">
            <button class="btn btn-success dropdown-toggle" type="button" id="dropdownTopluIslemler"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Toplu İşlemler
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownTopluIslemler">
              <button class="dropdown-item">Aylık Ödemeye Çevir</button>
              <button class="dropdown-item"></button>
              <button class="dropdown-item">Something else here</button>
            </div>
          </div>
          <p :class="{'d-none' : selectedCount == 0}">{{selectedCount}} adet cihaz seçili</p>
        </div>
      </div>
      <div class="row d-flex align-items-center border-bottom data-filter py-2">
        <div class="check-column"></div>
        <div class="col-2">
          <button class="btn btn-sm btn-secondary dropdown-toggle" type="button"
            id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Durum Filtresi
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <form class="py-2 px-4">
              <div class="form-group">
                <div class="custom-control custom-radio">
                  <input type="radio" id="rdSubStatus1" name="rdSubStatusFilter" value="0" v-model="filters.subscriptionStatus" class="custom-control-input">
                  <label class="custom-control-label" for="rdSubStatus1">Tümünü Göster</label>
                </div>
              </div>
              <div class="form-group">
                <div class="custom-control custom-radio">
                  <input type="radio" id="rdSubStatus2" name="rdSubStatusFilter" value="1" v-model="filters.subscriptionStatus" class="custom-control-input">
                  <label class="custom-control-label" for="rdSubStatus2">Aylık Ödemelileri Göster</label>
                </div>
              </div>
              <div class="form-group pb-0 mb-0">
                <div class="custom-control custom-radio">
                  <input type="radio" id="rdSubStatus3" name="rdSubStatusFilter" value="2" v-model="filters.subscriptionStatus" class="custom-control-input">
                  <label class="custom-control-label" for="rdSubStatus3">Yıllık Ödemelileri Göster</label>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="col-2">
          <div class="input-group input-group-sm p-0">
            <div class="input-group-prepend px-0">
              <button type="button" class="btn btn-secondary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span class="sr-only">Toggle Dropdown</span>
              </button>
              <div class="dropdown-menu">
                <form class="py-2 px-4">
                  <div class="form-group">
                    <div class="custom-control custom-radio">
                      <input type="radio" id="rdDeviceStatus1" name="rdDeviceStatusFilter" value="0" v-model="filters.deviceStatus" class="custom-control-input">
                      <label class="custom-control-label" for="rdDeviceStatus1">Tüm Cihazlarda Ara</label>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="custom-control custom-radio">
                      <input type="radio" id="rdDeviceStatus2" name="rdDeviceStatusFilter" value="1" v-model="filters.deviceStatus" class="custom-control-input">
                      <label class="custom-control-label" for="rdDeviceStatus2">Aktif Cihazlarda Ara</label>
                    </div>
                  </div>
                  <div class="form-group pb-0 mb-0">
                    <div class="custom-control custom-radio">
                      <input type="radio" id="rdDeviceStatus3" name="rdDeviceStatusFilter" value="2" v-model="filters.deviceStatus" class="custom-control-input">
                      <label class="custom-control-label" for="rdDeviceStatus3">Pasif Cihazlarda Ara</label>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <input type="text" class="form-control filter" maxlength="15" v-model="filters.deviceImei" placeholder="Imei filtresi">
          </div>
        </div>
        <div class="col-2">
          <div class="input-group input-group-sm p-0">
            <div class="input-group-prepend">
              <button class="btn btn-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Lenoi</button>
              <div class="dropdown-menu">
                <a class="dropdown-item" href="#">Tüm Bayiiler</a>
                <a class="dropdown-item" href="#">Lenoi</a>
                <a class="dropdown-item" href="#">Nokkon</a>
              </div>
            </div>
            <input type="text" class="form-control form-control-sm" maxlength="25" v-model="filters.customer" placeholder="Müşteri filtresi">
          </div>
        </div>
        <div class="col text-right"><div>Toplam <b>{{this.subCount}}</b> görüntüleniyor.</div></div>
        <div class="pager">
          <div class="input-group input-group-sm">
            <div class="input-group-prepend">
              <button class="btn btn-sm btn-secondary" @click="changePage(0)"><i class="fas fa-angle-left text-white"></i>&nbsp;&nbsp;Önceki</button>
            </div>
            <input type="number" class="form-control form-control-sm active-page text-center" v-model="filters.activePage">
            <div class="input-group-append">
              <button class="btn btn-sm btn-secondary" @click="changePage(1)">Sonraki&nbsp;&nbsp;<i class="fas fa-angle-right text-white"></i></button>
            </div>
          </div>
        </div>
      </div>
      <div class="row data-header">
        <div class="check-column">
          <div class="custom-control custom-checkbox text-center">
            <input type="checkbox" class="custom-control-input" id="customCheck1">
            <label class="custom-control-label" for="customCheck1"></label>
          </div>
        </div>
        <div class="col-2 data-tags">
          <i class="fas fa-sort mr-2"></i>
          <span>Durum</span>
        </div>
        <div class="col-2">
          <i class="fas fa-sort mr-2"></i>
          <span>Cihaz Seri No.</span>
        </div>
        <div class="col-2">
          <i class="fas fa-sort mr-2"></i>
          <span>Müşteri</span>
        </div>
        <div class="col-1">
          <i class="fas fa-sort mr-2"></i>
          <span>Kayıt</span>
        </div>
        <div class="col-1 text-truncate">
          <i class="fas fa-sort mr-2"></i>
          <span>Yenileme</span>
        </div>
        <div class="col-1 text-truncate">
          <i class="fas fa-sort mr-2"></i>
          <span>Bitiş</span>
        </div>
        <div class="col-1 text-truncate">
          <i class="fas fa-sort mr-2"></i>
          <span>Aidatsız</span>
        </div>
        <div class="col-1 text-truncate">
          <i class="fas fa-sort mr-2"></i>
          <span>Kullanım</span>
        </div>
        <div class="col text-truncate">
          <i class="fas fa-sort mr-2"></i>
          <span>Son</span>
        </div>
      </div>
      <div class="row data-content d-flex align-items-center" v-for="(rec, index) in filteredList" v-bind:key="'rec' + index">
        <div class="check-column">
          <div class="custom-control custom-checkbox text-center">
            <input type="checkbox" class="custom-control-input" :id="'chk' + index">
            <label class="custom-control-label" :for="'chk' + index"></label>
          </div>
          <!--<input type="checkbox" class="form-check-inline" :id="'chk' + index">-->
        </div>
        <div class="col-2">
          <span class="badge badge-success">AYLIK</span>
          <span class="badge badge-primary">YILLIK</span>
        </div>
        <div class="col-2">
          <p class="my-0 font-semi-bold">
            <a role="button" class="btn-link font-semi-bold">
              <i class="text-danger fas fa-circle" :class="{'d-none' : rec.DEVICE_ACTIVE == 1}"></i>
              <span>{{rec.DEVICE_ID}}</span>
            </a>
          </p>
          <small class="text-muted">{{rec.DEVICE_LABEL}}</small>
        </div>
        <div class="col-2">
          <p class="my-0 font-semi-bold">{{rec.CUSTOMER_TITLE}}</p>
          <small v-if="rec.VEHICLE_NAME" class="text-muted">{{rec.VEHICLE_NAME}} &bullet; </small><small class="text-muted">{{rec.GROUP_NAME}}</small>
        </div>
        <div class="col-1">{{rec.DATE_START_FORMATTED}}</div>
        <div class="col-1">{{rec.DATE_RENEWAL_FORMATTED}}</div>
        <div class="col-1">{{rec.DATE_NEXT_RENEWAL_FORMATTED}}</div>
        <div class="col-1">{{rec.SUBSCRIPTION}} gün</div>
        <div class="col-1">{{rec.TOTAL_DAYS}} gün + {{rec.A1_Transfer}} gün</div>
        <div class="col" :class="{'text-danger font-semi-bold' : rec.SUBSCRIPTION - rec.TOTAL_DAYS < 0}">
          {{parseInt(rec.SUBSCRIPTION) - parseInt(rec.TOTAL_DAYS)}} gün
        </div>
      </div>
    </div>
  </v-wait>
</template>

<script>
/* eslint-disable */

import axios from 'axios'

export default {
  name: 'RetailerSubscriptionPage',
  data () {
    return {
      searchFilter: '',
      subscriptions: [],
      selectedSubscriptions: [],
      retailerId: 1,
      status: 0,
      page: 0,
      subCount: 0,
      filters: {
        subscriptionStatus: '0',
        deviceStatus: '0',
        deviceImei: '',
        customer: '',
        activePage: 1
      }
    }
  },
  computed: {
    getPersonelId : function() { return this.$store.getters.getPersonelId },
    getSessionId : function() { return this.$store.getters.getSessionId },
    selectAll: {
      get: function () {
        return this.selectedSubscriptions ? this.subscriptions.length == this.selectedSubscriptions.length : false;
      },
      set: function (value) {
        var selected = [];
        if (value) {
          this.subscriptions.forEach(function (sub) {
            selected.push(sub);
          });
        }
        this.selectedSubscriptions = selected;
      }
    },
    selectedCount: {
      get: function() {
        return this.selectedSubscriptions.length;
      }
    },
    filteredList: {
      get: function() {
        if(this.searchFilter) {
          return this.subscriptions.filter(m => 
            (m.CUSTOMER_TITLE && m.CUSTOMER_TITLE.indexOf(this.searchFilter) > -1) ||
            (m.VEHICLE_NAME && m.VEHICLE_NAME.indexOf(this.searchFilter) > -1) ||
            (m.GROUP_NAME && m.GROUP_NAME.indexOf(this.searchFilter) > -1) ||
            (m.IMEINO && m.IMEINO.indexOf(this.searchFilter) > -1))
        } else return this.subscriptions
      }
    },
    pageCount: {
      get: function() {
        return Math.round(this.subCount / 20)
      }
    },
  },
  methods: {
    async getSubscriptions() {
      this.$wait.start('subs-loading')
      let p = this.page <= 0 ? 0 : this.page - 1
      axios.post('/api/retailer/subscriptions?sessionid=' 
        + this.getSessionId + '&retailerId=' + this.retailerId + '&status=' + this.status + '&page=' + p)
      .then(response => {
        this.subscriptions = response.data
        this.$wait.end('subs-loading')
      })
      .catch(error => { 
        console.error(error) 
        this.$wait.end('subs-loading')
      })
    },
    async getSubscriptionsCount() {
      axios.post('/api/retailer/subscriptions-count?sessionid=' 
        + this.getSessionId + '&retailerId=' + this.retailerId + '&status=' + this.status)
      .then(response => {
        this.subCount = response.data[0].IMEI_COUNT
      })
      .catch(error => { 
        console.error(error) 
      })
    },
    cropData(val, len) { 
      if(val == null || val == undefined)
        return null;

      if((val.length + 3) > len) return val.substring(0, len) + '...' 
      else return val
    },
    onchange() {
      this.subscriptions = []
      this.page = 0
      this.getSubscriptionsCount()
      this.getSubscriptions()
    },
    changePage(t) {
      console.log(t + " - " + this.filters.activePage + " - " + this.pageCount);
      if(t==0 && this.filters.activePage > 1) this.filters.activePage--;
      else if(t==1 && this.filters.activePage <= this.pageCount) this.filters.activePage++;
    }
  },
  beforeCreate() {
  },
  created() {
    this.$wait.start('subs-loading')
  },
  mounted() {
    this.getSubscriptionsCount()
    this.getSubscriptions()
  },
  watch: {
    page: function() { this.getSubscriptions() }
  }
}
</script>

<style lang="css">

  a.btn-link { cursor: pointer; }

  a.btn-link:hover { text-decoration: underline !important; }

  /* data-table */
  .badge { font-weight: 600; padding: 6px 8px 4px 8px !important; }

  .fixed-margin {
    margin-top: 120px;
    z-index: 2;
  }

  .check-column {
    width: 60px;
    text-align: center;
  }

  .check-column input[type=checkbox] {
    padding: 0;
    margin: 0;
  }

  .check-column .custom-control {
    margin-left: 12px;
  }

  .data-header {
    background-color: #EFEFEF;
    border-bottom: 2px solid #E0E0E0;
  }

  .data-header-fixed {
    position: fixed;
    width: calc(100vw - 67) !important;
    background-color: brown;
    margin-bottom: 50px;
  }

  .data-header > div {
    padding: 8px 12px;
    font-weight: 600;
  }

  .data-content {
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #E0E0E0;
  }

  .data-content > div, .data-filter > div {
    font-size: .875rem;
    font-weight: 400;
    padding: 0 12px;
  }

  .data-filter {
    background-color: #F7F7F7;
  }

  .data-filter input[type=text].filter {
    width: 80% !important;
  }

  .data-filter input[type=number].active-page {
    width: 60px !important;
    max-width: 60px !important;
  }

  .data-filter input.active-page::-webkit-outer-spin-button,
  .data-filter input.active-page::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .pager {
    float: right !important;
  }

  /* end data-table */

  .font-semi-bold {
    font-weight: 600;
  }

  .custom-control-label { font-weight: 400; }

  .text-truncate {
    display: block !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }
  .font-big {
    font-size: .875rem;
  }
  .vue-wait-class {
    display: block;
    width: 300px;
    text-align: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
  }
  .vue-wait-class img {
    width: 160px;
    height: 160px;
    margin: 10px auto 0 auto;
    clear: both;
  }
  .vue-wait-class p {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }
  .pagination {
    margin-top: 15px;
  }
  .pagination li {
    font-size: 1rem;
    border: 1px solid #F0F0F0;
    border-right: none;
    font-weight: 500;
    width: 72px;
    height: 48px;
    align-content: center;
    padding: 12px 18px;
  }
  .pagination li a {
    color: #1888ff;
  }
  .pagination li:last-child {
    border-right: 1px solid #F0F0F0;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  .pagination li:first-child {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
  .pagination li.page-item {
    width: 48px;
    height: 48px;
    padding-left: 18px;
    padding-right: 18;
  }
  .pagination li.page-item.active {
    background-color: #1888ff;
  }
  .pagination li.page-item.active a {
    color: #FFFFFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/RetailerSubscriptionPage.vue